import React, { Component } from 'react';
import { Menu, Table, Image } from 'antd';

import './index.scss';

export default class BudgetCommonPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedConstructionIndex: '0',
        };
    }

    changeSelectMenu = ({ key }) => {
        this.setState({
            selectedConstructionIndex: key,
        });
    };

    initMenuItems = () => {
        let { budgetData } = this.props;

        //project
        let menu = budgetData[this.props.name] || [];

        return menu.map((item, index) => {
            return <Menu.Item key={index}>{item.name}</Menu.Item>;
        });
    };

    initTable = () => {
        let { budgetData, name } = this.props;
        let panel = budgetData[name];
        if (!panel) return null;
        const data = panel[this.state.selectedConstructionIndex]?.list || [];
        let columnsMap = {
            project: [
                {
                    title: intl.get('budgetCommonPanel.projectNum'),
                    dataIndex: 'sn',
                    key: 'sn',
                },
                {
                    title: intl.get('budgetCommonPanel.projectName'),
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    title: intl.get('budgetCommonPanel.unit'),
                    dataIndex: 'unitId',
                    key: 'unitId',
                },
                {
                    title: intl.get('budgetCommonPanel.count'),
                    key: 'num',
                    dataIndex: 'num',
                },
                {
                    title: intl.get('budgetCommonPanel.countMoney'),
                    key: 'countMoney',
                    dataIndex: 'countMoney',
                },
                {
                    title: intl.get('budgetCommonPanel.unitMoney'),
                    key: 'unitMoney',
                    dataIndex: 'unitMoney',
                },
                {
                    title: intl.get('budgetCommonPanel.machineryMoney'),
                    key: 'machineryMoney',
                    dataIndex: 'machineryMoney',
                },
                {
                    title: intl.get('budgetCommonPanel.lossRate'),
                    key: 'lossRate',
                    dataIndex: 'lossRate',
                },
                {
                    title: intl.get('budgetCommonPanel.rate'),
                    key: 'rate',
                    dataIndex: 'rate',
                },
                {
                    title: intl.get('budgetCommonPanel.remark'),
                    key: 'remark',
                    dataIndex: 'remark',
                },
                {
                    title: intl.get('budgetCommonPanel.main'),
                    key: 'main',
                    dataIndex: 'main',
                },
                {
                    title: intl.get('budgetCommonPanel.note'),
                    key: 'note',
                    dataIndex: 'note',
                },
            ],
            auxiliaryMaterial: [
                {
                    title: intl.get('budgetCommonPanel.sn'),
                    dataIndex: 'sn',
                    key: 'sn',
                },
                {
                    title: intl.get('budgetCommonPanel.materialDetail'),
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    title: intl.get('budgetCommonPanel.useUnit'),
                    dataIndex: 'unitId',
                    key: 'unitId',
                },
                {
                    title: intl.get('budgetCommonPanel.materialUse'),
                    key: 'num',
                    dataIndex: 'num',
                },
                {
                    title: intl.get('budgetCommonPanel.brandName'),
                    key: 'brandName',
                    dataIndex: 'brandName',
                },
                {
                    title: intl.get('budgetCommonPanel.standard'),
                    key: 'standard',
                    dataIndex: 'standard',
                },
                {
                    title: intl.get('budgetCommonPanel.sellMoney'),
                    key: 'sellMoney',
                    dataIndex: 'sellMoney',
                },
                {
                    title: intl.get('budgetCommonPanel.lossRate'),
                    key: 'lossRate',
                    dataIndex: 'lossRate',
                },
                {
                    title: intl.get('budgetCommonPanel.rate'),
                    key: 'rate',
                    dataIndex: 'rate',
                },
                {
                    title: intl.get('budgetCommonPanel.remark'),
                    key: 'money',
                    dataIndex: 'money',
                },
                {
                    title: intl.get('budgetCommonPanel.description'),
                    key: 'note',
                    dataIndex: 'note',
                },
            ],
            hardMountingMaterials: [
                {
                    title: intl.get('budgetCommonPanel.number'),
                    dataIndex: 'sn',
                    key: 'sn',
                },
                {
                    title: intl.get('budgetCommonPanel.type'),
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    title: intl.get('budgetCommonPanel.location'),
                    dataIndex: 'site',
                    key: 'site',
                },
                {
                    title: intl.get('budgetCommonPanel.projectDrawing'),
                    key: 'pruduceImage',
                    dataIndex: 'pruduceImage',
                    render: (title, record) => {
                        return (
                            <div className="image-text">
                                <Image src={record.modelImage}></Image>
                                {record.modelName}
                            </div>
                        );
                    },
                },
                {
                    title: intl.get('budgetCommonPanel.brandName'),
                    key: 'brandName',
                    dataIndex: 'brandName',
                },
                {
                    title: intl.get('budgetCommonPanel.produceNum'),
                    key: 'produceNum',
                    dataIndex: 'produceNum',
                },
                {
                    title: intl.get('budgetCommonPanel.produceCode'),
                    key: 'produceCode',
                    dataIndex: 'produceCode',
                },

                {
                    title: intl.get('budgetCommonPanel.norms'),
                    key: 'standard',
                    dataIndex: 'standard',
                },
                {
                    title: intl.get('budgetCommonPanel.material'),
                    key: 'texture',
                    dataIndex: 'texture',
                },
                {
                    title: intl.get('budgetCommonPanel.unitPrice'),
                    key: 'unitName',
                    dataIndex: 'unitName',
                },

                {
                    title: intl.get('budgetCommonPanel.count'),
                    key: 'num',
                    dataIndex: 'num',
                },
                {
                    title: intl.get('budgetCommonPanel.unitPrice'),
                    key: 'unitMoney',
                    dataIndex: 'unitMoney',
                },
                {
                    title: intl.get('budgetCommonPanel.lossRate'),
                    key: 'lossRate',
                    dataIndex: 'lossRate',
                },
                {
                    title: intl.get('budgetCommonPanel.rate'),
                    key: 'rate',
                    dataIndex: 'rate',
                },
                {
                    title: intl.get('budgetCommonPanel.remark'),
                    key: 'countMoney',
                    dataIndex: 'countMoney',
                },
                {
                    title: intl.get('budgetCommonPanel.description'),
                    key: 'note',
                    dataIndex: 'note',
                },
            ],
            upholsteredFurniture: [
                {
                    title: intl.get('budgetCommonPanel.number'),
                    dataIndex: 'sn',
                    key: 'sn',
                },
                {
                    title: intl.get('budgetCommonPanel.type'),
                    dataIndex: 'catName',
                    key: 'catName',
                },
                {
                    title: intl.get('budgetCommonPanel.projectDrawing'),
                    key: 'pruduceImage',
                    dataIndex: 'pruduceImage',
                    render: (title, record) => {
                        return (
                            <div>
                                <Image src={record.modelImage}></Image>
                                {record.modelName}
                            </div>
                        );
                    },
                },
                {
                    title: intl.get('budgetCommonPanel.brandName'),
                    key: 'brandName',
                    dataIndex: 'brandName',
                },
                {
                    title: intl.get('budgetCommonPanel.produceNum'),
                    dataIndex: 'produceNum',
                    key: 'produceNum',
                },
                {
                    title: intl.get('budgetCommonPanel.produceCode'),
                    dataIndex: 'produceCode',
                    key: 'produceCode',
                },
                {
                    title: intl.get('budgetCommonPanel.modelSize'),
                    dataIndex: 'modelSize',
                    key: 'modelSize',
                },
                {
                    title: intl.get('budgetCommonPanel.produceSize'),
                    key: 'produceSize',
                    dataIndex: 'produceSize',
                },
                {
                    title: intl.get('budgetCommonPanel.unit'),
                    key: 'unitId',
                    dataIndex: 'unitId',
                },
                {
                    title: intl.get('budgetCommonPanel.count'),
                    key: 'num',
                    dataIndex: 'num',
                },
                {
                    title: intl.get('budgetCommonPanel.unitPrice'),
                    key: 'unitPrice',
                    dataIndex: 'unitPrice',
                },
                {
                    title: intl.get('budgetCommonPanel.rate'),
                    key: 'rate',
                    dataIndex: 'rate',
                },
                {
                    title: intl.get('budgetCommonPanel.remark'),
                    key: 'money',
                    dataIndex: 'money',
                },
                {
                    title: intl.get('budgetCommonPanel.description'),
                    key: 'note',
                    dataIndex: 'note',
                },
            ],
        };

        return (
            <Table
                className="budget-privew"
                size="small"
                columns={columnsMap[this.props.name]}
                pagination={false}
                dataSource={data}></Table>
        );
    };

    initTitle = () => {
        let { budgetData, name } = this.props;
        let panel = budgetData[name]?.[this.state.selectedConstructionIndex];
        if (!panel) return null;
        const {
            name: itemName,
            area,
            perimeter,
            money,
            total,
            wallArea,
        } = panel;
        return (
            <div className="title">
                <span className="item-name">{itemName}</span>
                {intl.get('budgetCommonPanel.area', {
                    area,
                    perimeter,
                    wallArea,
                    total,
                })}
                <span className="money">￥{money}</span>
            </div>
        );
    };

    render() {
        return (
            <div className="common-panel-wrapper">
                <Menu
                    defaultSelectedKeys={this.state.selectedConstructionIndex}
                    onSelect={this.changeSelectMenu}>
                    {this.initMenuItems()}
                </Menu>
                <div className="panel">
                    {this.initTitle()}
                    {this.initTable()}
                </div>
            </div>
        );
    }
}
